// extracted by mini-css-extract-plugin
module.exports = {"container":"blog-home-hero-article-carousel_container__joya0","box":"blog-home-hero-article-carousel_box__6oVXz"};